import { Order } from '@/models/order.model';
import { SFContactModel } from '@/models/sf-contact.model';
import { ValidatorResult } from '@/models/validation-result.model';
import type { AccountDetailsResponseDto, AccountModel } from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class AccountsService {
  private crudService: CrudService<Order>;

  constructor() {
    this.crudService = new CrudService<Order>('accounts');
  }

  public async getContacts(accountId: string): Promise<ValidatorResult<SFContactModel[]>> {
    return await this.crudService.do('get', 'contacts?accountId=' + accountId);
  }

  public async getAccounts(accountId: string, accountIds: string[]): Promise<ValidatorResult<AccountModel[]>> {
    return await this.crudService.do('get', `accounts?accountId=` + accountId + `&accountIds=` + accountIds);
  }

  public async getAccountDetails(accountId: string): Promise<ValidatorResult<AccountDetailsResponseDto | undefined>> {
    return await this.crudService.do('get', `?accountId=` + accountId);
  }
}
